export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/appVersion/query`,
          data
        });
      },
      list(data){
          return http.json({
              url: `/appVersion/backList`,
              data
          });
      },
      /**
       * 保存版本信息
       * @param data
       * @return {*}
       */
      saveAppVersion(data) {
          return http.json({
              url: '/appVersion/save',
              data
          })
      },
      /**
       * 获取版本详情
       * @param data
       * @return {*}
       */
      getNoticeInfo(data) {
          return http.json({
              url: `/appVersion/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      removeNotice(data) {
          return http.json({
              url: `/appVersion/delete?id=${data[0].id}`,
              data
          })
      },

      /**
       * 是否强制下载某版本
       * @param data
       * @return {*}
       */
      showOrHidden(data) {
        return http.json({
            url: `/appVersion/showOrHidden?id=${data.id}&state=${data.state}`,
            data
        })
    },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/appVersion.js